import React from "react";
import { EntityContextInterface } from "module/entity/context/entity/EntityContext";

export type CertificationContextInterface = EntityContextInterface;

const CertificationContext = React.createContext(
  <CertificationContextInterface>{}
);

export default CertificationContext;
